import { mockFolders, mockFolders2, mockMessages, mockTags } from './messages';
import { mockNotifications, mockStats, mockTodo } from './notifications';

import mockActivity from './activity';
import { mockChart } from './chart';
import mockChats from './chats';
import mockContacts from './contacts';
import mockDashboard from './dashboard';
import mockEvents from './calendar';
import mockFeed from './feed';
import mockInvoice from './invoice';
import mockPricing from './pricing';
import mockProduct from './product';
import mockReviews from './reviews';
import mockTaskboard from './taskboard';
import mockTimeline from './timeline';

export {
  mockEvents,
  mockChats,
  mockContacts,
  mockFolders,
  mockFolders2,
  mockTags,
  mockMessages,
  mockNotifications,
  mockStats,
  mockTodo,
  mockTimeline,
  mockActivity,
  mockInvoice,
  mockPricing,
  mockTaskboard,
  mockFeed,
  mockProduct,
  mockReviews,
  mockChart,
  mockDashboard
};
